module.exports = __webpack_public_path__ + "static/contact_bg-03f999018428fb54264b541334d1edab.svg";